<template>
	<div class="container modularFour">
		<div class="part">
			<div
				v-if="showTitle == 1 "
				class="title"
			>
				<span class="span">{{title}}</span>
				<!-- <div v-if="isMore !== '0' " class="more" @click="goBanner">
					{{$t('index.3-txt2')}}
					<i class="el-icon-arrow-right"></i>
				</div> -->
			</div>
			<div class="box">
				<div class="goods_item" v-for="(item,index) in goodsData" :key="index" @click="goPage(item)">
					<img class="goods_img" :src="item.img">
				</div>
				<!-- <carousel :items="items" :margin="30" :loop="true" :dots="false" :nav="false" :autoplay="true" v-if="goodsData.length>0">
					<template slot="prev"><span class="prev"><i class="el-icon-arrow-left"></i></span></template>
					<div class="goods_item" v-for="(item,index) in goodsData" :key="index" @click="goDetail(item.id)">
						<img class="goods_img" :src="item.img">
					</div>
					<template slot="next"><span class="next"><i class="el-icon-arrow-right"></i></span></template>
				</carousel> -->
			</div>
		</div>
	</div>
</template>

<script>
	import bus from '../../assets/bus';
	import carousel from '../../plug/Carousel.vue'
	export default {
		props:{
			componentType:{
				type:String,
				default:""
			},
			componentId:{
				type:String,
				default:""
			}
		},
		components: {
			carousel
		},
		data() {
			return {
				goodsData:[],
				title:'',
				items:5,
				
				// 
				showTitle: '',
			}
		},
		created(){
			this.getData()
		},
		mounted() {
			this.onSize()
		},
		methods: {
			onSize(){
				var clientWidth = document.documentElement.clientWidth
				if(clientWidth<768){
					this.items=2
				}else if(clientWidth<992){
					this.items=3
				}else if(clientWidth<1200){
					this.items=4
				}
			},
			getData(){
				const url = "/index.php/AppInterface/IndexModule"+this.componentType+"/index"
				this.$server.post(url, {
					id: this.componentId,
				})
				.then(res => {
					switch (res.result) {
						case 1:
							this.goodsData = res.data.index_arr.item_arr||[]
							
							
							this.title =  res.data.index_arr.name
							this.showTitle = res.data.index_arr.config_json.show_title
							break;
						default:
							uni.showToast({
								icon: "none",
								title: res.data.msg
							});
							break;
					}
				})
			},
			goPage(item){
				if(item.relevance_type == 1) {
					bus.$emit('goProduct', {
						path:"/productDetail",
						query:{
							id: item.relevance_id
						}
					})
				}
				// 商品分类
				else if(item.relevance_type == 2) {
					// url:"/pages/navigation/index?id="+item.relevance_id+"&componentId="+item.componentId
					bus.$emit('goProduct', {
						path: '/classify',
						query: {
							type: 1,
							id: item.relevance_id,
							componentId: item.componentId,
						}
					})
				}
				// 品牌
				else if(item.relevance_type == 3) {
					console.log('goBanner goBrand')
					bus.$emit('goProduct', {
						path: '/classify',
						query: {
							type: 0,
							id: item.relevance_id,
							componentId: item.componentId,
						}
					})
				}
			}
		}
	}
</script>

<style lang="scss">
	.modularFour {
		margin: 0 auto;
		width: $container-MaxWidth;
		max-width: $container-MaxWidth;
		min-width: $container-MaxWidth;

		.part {
			padding: 25px 0;

			.title {
				position: relative;
				height: 60px;
				margin-bottom: 25px;
				// border-bottom: 1px solid #f2f2f2;
				// font-size: 24px;
				
				.span {
					display: block;
					padding-bottom: 4px;
					// border-bottom: 2px solid $defaultColor;
					font-size: 20px;
					line-height: 60px;
					font-weight: bold;
					text-align: center;
					
					&:before,
					&:after
					{
						content: '———';
						margin: 0 6px;
					}
				}
				.more {
					position: absolute;
					right: 0;
					top: 0;
					height: 60px;
					color: #666;
					font-size: 14px;
					line-height: 60px;
					cursor: pointer;
					
					&:hover {
						text-decoration: underline;
					}
				}
			}
			
			.box {
				position: relative;
				overflow: hidden;
				.goods_item {
					float: left;
					width: 33.33%;
					// height: 700px;
					overflow: hidden;
					cursor: pointer;
					// background-color: #fff;
					.goods_img {
						width: 100%;
						// height: 100%;
						object-fit: cover;
						display: block;
					}
				}
			}
			@media (max-width: 768px){
				.box {
					padding: 0 10px;
					.goods_item {
						width: 50%;
					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/modular/modular_four.vue